import React from 'react';
import PropTypes from 'prop-types';
import { RenderModule, composeModules } from 'holocron';
import { updateLocale, setRenderPartialOnly } from '@americanexpress/one-app-ducks';
import getSafeLocaleUtil from '../../utils/getSafeLocaleUtil';

const Partial = ({ params: { moduleName, ...params }, ...props }) => (
  <RenderModule
    moduleName={moduleName}
    props={{
      params,
      ...props,
    }}
  />
);

export const onPartialRouteEnter = (
  { dispatch }, partialOnly = false
) => async (props, replace, onLoadComplete) => {
  const { locale: unsafeLocale, moduleName: name } = props.params;
  await dispatch(setRenderPartialOnly(partialOnly));
  await dispatch(updateLocale(getSafeLocaleUtil(unsafeLocale, dispatch)));
  await dispatch(composeModules([{
    name,
    props,
  }]));
  onLoadComplete();
};

Partial.propTypes = {
  params: PropTypes.shape({
    moduleName: PropTypes.string.isRequired,
  }).isRequired,
};

export default Partial;
